<template>
  <v-container fluid>
    <v-form ref="form" v-model="valid">
      <v-card class="mb-4">
        <v-card-title>Thông tin xe (Hàng Chính Ngạch)</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field v-model="item.LicensePlate" label="Biển số xe / 车牌 *" :rules="[v => !!v || 'Bắt buộc']" outlined dense></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field v-model="item.TruckCode" label="Mã xe (Hệ thống tự tạo)" readonly outlined dense class="grey lighten-4"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-menu v-model="menuLoading" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="item.LoadingDate" label="Ngày bốc hàng / 加载日期" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense clearable></v-text-field>
                </template>
                <v-date-picker v-model="loadingDateVal" @input="updateLoadingDate"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <v-menu v-model="menuUnload" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="item.UnloadDate" label="Ngày hạ hàng / 卸货日期" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense clearable></v-text-field>
                </template>
                <v-date-picker v-model="unloadDateVal" @input="updateUnloadDate"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <v-select v-model="item.Status" :items="statusList" item-text="text" item-value="value" label="Trạng thái" outlined dense></v-select>
            </v-col>
          </v-row>
          
          <v-row>
             <v-col cols="12">
                <v-file-input
                  v-model="filesToUpload"
                  label="Upload tờ khai (PDF, Hình ảnh...)"
                  multiple
                  outlined
                  dense
                  prepend-icon="mdi-paperclip"
                >
                  <template v-slot:append-outer>
                    <v-btn small color="primary" @click="uploadFiles" :loading="uploading" :disabled="!filesToUpload || filesToUpload.length === 0">Upload</v-btn>
                  </template>
                </v-file-input>
             </v-col>
             <!-- Display current declarations -->
             <v-col cols="12" v-if="declarationFiles && declarationFiles.length > 0">
                 <b>Tờ khai đã upload:</b>
                 <v-chip v-for="(file, idx) in declarationFiles" :key="idx" class="ma-1" close @click:close="removeFile(idx)" :href="getMediaUrl(file.url)" target="_blank">
                    {{ file.name }}
                 </v-chip>
             </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Stats section -->
      <v-row class="mb-4">
          <v-col cols="3">
              <v-card color="blue lighten-5">
                  <v-card-text class="text-center">
                      <div class="subtitle-2">Tổng Cân / KG</div>
                      <div class="text-h5 font-weight-bold">{{ item.TotalWeight || 0 }}</div>
                  </v-card-text>
              </v-card>
          </v-col>
          <v-col cols="3">
              <v-card color="green lighten-5">
                  <v-card-text class="text-center">
                      <div class="subtitle-2">Tổng Khối / M3</div>
                      <div class="text-h5 font-weight-bold">{{ item.TotalVolume || 0 }}</div>
                  </v-card-text>
              </v-card>
          </v-col>
          <v-col cols="3">
              <v-card color="orange lighten-5">
                  <v-card-text class="text-center">
                      <div class="subtitle-2">Tổng Kiện / 包裹</div>
                      <div class="text-h5 font-weight-bold">{{ item.TotalPackages || 0 }}</div>
                  </v-card-text>
              </v-card>
          </v-col>
          <v-col cols="3">
              <v-card color="purple lighten-5">
                  <v-card-text class="text-center">
                      <div class="subtitle-2">Tổng Mã (Order) / 产品</div>
                      <div class="text-h5 font-weight-bold">{{ selectedOrders.length }}</div>
                  </v-card-text>
              </v-card>
          </v-col>
      </v-row>

      <v-card>
        <v-card-title>
          Đơn hàng trên xe (Chỉ CHỜ THÔNG QUAN)
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            class="mr-2"
            small
            :disabled="!isEdit"
            @click="exportPdf"
          >
            <v-icon left>mdi-file-pdf-box</v-icon> Xuất PDF
          </v-btn>
          <v-btn
            color="success"
            class="mr-2"
            small
            :disabled="!canMarkUnloaded"
            @click="markUnloaded"
          >
            <v-icon left>mdi-truck-check</v-icon> Hạ hàng nhập kho VN
          </v-btn>
          <v-btn color="primary" @click="dialogOrders = true" small>
            <v-icon left>mdi-plus</v-icon> Chọn đơn hàng
          </v-btn>
        </v-card-title>
        <v-data-table
          :headers="orderHeaders"
          :items="selectedOrders"
          disable-pagination
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:item.action="{ item }">
            <v-btn icon small color="error" @click="removeOrder(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-form>

    <!-- Dialog choose orders -->
    <v-dialog v-model="dialogOrders" max-width="900px">
        <v-card>
            <v-card-title>Chọn đơn hàng (Chờ thông quan)</v-card-title>
            <v-card-text>
                <v-data-table
                    v-model="tempSelectedOrders"
                    :headers="orderHeaders"
                    :items="pendingOrders"
                    show-select
                    item-key="ID"
                    class="elevation-1"
                    :loading="loadingPending"
                >
                </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialogOrders = false">Hủy</v-btn>
                <v-btn color="primary" @click="confirmAddOrders">Xác nhận</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'
import { sendSuccessNotice, sendErrorNotice } from '@/commons/utils'
import configs from '@/configs'

export default {
  name: 'CnTruckDetail',
  data() {
    return {
      valid: false,
      item: {
        ID: 0,
        LicensePlate: '',
        TruckCode: '',
        LoadingDate: null,
        UnloadDate: null,
        Status: 1,
        DeclarationFiles: null,
        TotalWeight: 0,
        TotalVolume: 0,
        TotalPackages: 0,
        TotalProducts: 0
      },
      filesToUpload: [],
      uploading: false,
      declarationFiles: [],
      menuLoading: false,
      loadingDateVal: null,
      menuUnload: false,
      unloadDateVal: null,
      statusList: [
        { text: 'Đang xếp / 加载中', value: 1 },
        { text: 'Đã hạ hàng / 已卸货', value: 2 },
      ],
      selectedOrders: [],
      dialogOrders: false,
      tempSelectedOrders: [],
      pendingOrders: [],
      loadingPending: false,
      orderHeaders: [
          { text: 'ID', value: 'ID' },
          { text: 'Mã ĐH', value: 'OrderCode' },
          { text: 'Khách hàng', value: 'CustomerCode' },
          { text: 'Loại VC', value: 'TransportType' },
          { text: 'Tổng KGM', value: 'TotalKGM' },
          { text: 'Tổng Cân', value: 'TotalWeight' },
          { text: 'Tổng Khối', value: 'TotalVolume' },
          { text: 'Xóa', value: 'action', sortable: false }
      ]
    }
  },
  computed: {
    isEdit() {
      return this.$route.params.Pid && this.$route.params.Pid !== '0'
    },
    canMarkUnloaded() {
      return this.isEdit && Number(this.item.Status) === 1 && this.selectedOrders.length > 0
    }
  },
  watch: {
    '$route.params.Pid'(newVal, oldVal) {
      if (newVal && newVal !== '0' && newVal !== oldVal) {
        this.fetchDetail()
      }
    },
    dialogOrders(val) {
        if (val) {
            this.fetchPendingOrders()
            // check existing
            this.tempSelectedOrders = this.pendingOrders.filter(p => this.selectedOrders.some(s => s.ID === p.ID))
                .concat(this.selectedOrders);
        }
    }
  },
  async created() {
    if (this.isEdit) {
      await this.fetchDetail()
    } else {
      this.setDefaultLoadingDate()
    }
  },
  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', { invisibleSaveButton: false })
    this.$root.$on('REQUEST_SAVE_DATA', this.save)
    this.$root.$on('REQUEST_REFRESH_DATA', this.fetchDetail)
  },
  beforeDestroy() {
    this.$root.$off('REQUEST_SAVE_DATA', this.save)
    this.$root.$off('REQUEST_REFRESH_DATA', this.fetchDetail)
  },
  methods: {
    setDefaultLoadingDate() {
      const today = new Date()
      const yyyy = today.getFullYear()
      const mm = String(today.getMonth() + 1).padStart(2, '0')
      const dd = String(today.getDate()).padStart(2, '0')
      const dateText = `${yyyy}-${mm}-${dd}`
      this.loadingDateVal = dateText
      this.item.LoadingDate = `${dateText} 00:00:00`
    },
    getMediaUrl(url) {
      // Very simple helper since sometimes files might have absolute path or relative
      if (!url) return '#'
      if (url.startsWith('http')) return url;
      if (!url.startsWith('/')) url = '/' + url;
      // You should configure base properly but this matches existing system
      return window.location.origin + ':8001' + url;
    },
    updateLoadingDate(val) {
      this.item.LoadingDate = val + ' 00:00:00'
      this.menuLoading = false
    },
    updateUnloadDate(val) {
      this.item.UnloadDate = val + ' 00:00:00'
      this.menuUnload = false
    },
    async fetchDetail() {
      try {
        const res = await ApiService.get(`/api/cn-trucks/${this.$route.params.Pid}`)
        const data = res.data.data
        this.item = Object.assign({}, data)
        this.selectedOrders = data.orders || []
        
        if (this.item.DeclarationFiles) {
            try {
                this.declarationFiles = JSON.parse(this.item.DeclarationFiles)
            } catch(e) {
                this.declarationFiles = []
            }
        }
        
        if (this.item.LoadingDate) this.loadingDateVal = this.item.LoadingDate.split(' ')[0]
        if (this.item.UnloadDate) this.unloadDateVal = this.item.UnloadDate.split(' ')[0]
      } catch (error) {
        console.error(error)
        sendErrorNotice('Lỗi khi tải chi tiết xe')
      }
    },
    async fetchPendingOrders() {
        this.loadingPending = true
        try {
            const res = await ApiService.query(`/api/cn-trucks/pending-orders/`)
            this.pendingOrders = res.data.data || []
        } catch(e) {
            console.error(e)
        } finally {
            this.loadingPending = false
        }
    },
    confirmAddOrders() {
        const currentIds = this.selectedOrders.map(o => o.ID)
        const toAdd = this.tempSelectedOrders.filter(o => !currentIds.includes(o.ID))
        this.selectedOrders.push(...toAdd)
        this.dialogOrders = false
        this.recalcPreview()
    },
    removeOrder(order) {
        this.selectedOrders = this.selectedOrders.filter(o => o.ID !== order.ID)
        this.recalcPreview()
    },
    recalcPreview() {
        // Just for visual preview before save. Actual calculation done in backend.
        let wt = 0, vol = 0
        for(let o of this.selectedOrders) {
            wt += parseFloat(o.TotalWeight || 0)
            vol += parseFloat(o.TotalVolume || 0)
        }
        this.item.TotalWeight = wt
        this.item.TotalVolume = vol
    },
    async uploadFiles() {
        if (!this.filesToUpload || this.filesToUpload.length === 0) return;
        this.uploading = true;
        
        try {
            let formData = new FormData()
            for (let i = 0; i < this.filesToUpload.length; i++) {
                formData.append('files', this.filesToUpload[i])
            }
            
            const res = await ApiService.post('/api/files/upload-multiple/', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            
            if (res.data.status) {
                // res.data.data.uploaded_files is array of { name, url, ... }
                const uploaded = (res.data.data && res.data.data.uploaded_files) || [];
                this.declarationFiles = [...this.declarationFiles, ...uploaded]
                this.filesToUpload = []
                if (this.isEdit) {
                  await this.persistDeclarationFiles()
                  sendSuccessNotice('Upload và lưu tờ khai thành công')
                } else {
                  sendSuccessNotice('Upload thành công, vui lòng bấm Lưu để gắn tờ khai vào xe hàng')
                }
            } else {
                sendErrorNotice('Upload thất bại')
            }
        } catch(e) {
            console.error(e)
            sendErrorNotice('Lỗi upload file')
        } finally {
            this.uploading = false;
        }
    },
    removeFile(idx) {
        this.declarationFiles.splice(idx, 1)
        if (this.isEdit) {
          this.persistDeclarationFiles().catch((e) => {
            console.error(e)
            sendErrorNotice('Lỗi lưu thay đổi tờ khai')
          })
        }
    },
    async persistDeclarationFiles() {
      if (!this.isEdit || !this.item.ID) {
        return
      }
      await ApiService.post(`/api/cn-trucks/${this.item.ID}`, {
        DeclarationFiles: JSON.stringify(this.declarationFiles)
      })
    },
    async markUnloaded() {
      if (!this.canMarkUnloaded) {
        return
      }
      if (!confirm('Xác nhận hạ toàn bộ xe và chuyển vận đơn sang trạng thái Nhập kho VN?')) {
        return
      }

      try {
        await ApiService.post(`/api/cn-trucks/${this.item.ID}/mark-unloaded/`, {})
        sendSuccessNotice('Hạ hàng thành công')
        await this.fetchDetail()
      } catch (error) {
        console.error(error)
        const message = (error && error.response && error.response.data && error.response.data.reason)
          ? error.response.data.reason
          : 'Lỗi khi hạ hàng'
        sendErrorNotice(message)
      }
    },
    async save() {
      if (!this.$refs.form.validate()) {
        sendErrorNotice('Vui lòng điền đầy đủ thông tin bắt buộc')
        return
      }
      
      const payload = Object.assign({}, this.item)
      // Never send non-table relational data to truck update API
      if (payload.orders) {
        delete payload.orders
      }
      payload.DeclarationFiles = JSON.stringify(this.declarationFiles)
      payload.OrderIDs = this.selectedOrders.map(o => o.ID)
      
      try {
        if (this.isEdit) {
          await ApiService.post(`/api/cn-trucks/${this.item.ID}`, payload)
          sendSuccessNotice('Cập nhật thành công')
          await this.fetchDetail()
        } else {
          const res = await ApiService.put('/api/cn-trucks/', payload)
          sendSuccessNotice('Thêm mới thành công')
          // redirect to edit page — fetchDetail will be triggered by route watcher
          if (res.data.data && res.data.data.ID) {
            await this.$router.replace(`/hang-chinh-ngach/xep-xe/${res.data.data.ID}`)
          }
        }
      } catch (error) {
        console.error(error)
        const message = (error && error.response && error.response.data && error.response.data.reason)
          ? error.response.data.reason
          : 'Lỗi khi lưu dữ liệu'
        sendErrorNotice(message)
      }
    },
    async exportPdf() {
      if (!this.isEdit || !this.item.ID) return
      try {
        const token = this.$store.state.authentication.token
        const headers = {
          Authorization: `Bearer ${token}`
        }
        const url = `${configs.API}/api/cn-trucks/${this.item.ID}/export-pdf/`
        const response = await this.$http.get(url, { headers, responseType: 'blob' })
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `KhaiBao_${this.item.TruckCode || this.item.ID}.pdf`
        link.click()
        sendSuccessNotice('Xuất file PDF thành công')
      } catch (error) {
        console.error(error)
        sendErrorNotice('Lỗi khi xuất PDF')
      }
    }
  }
}
</script>
